import { OfferingStage } from '../../../graphql';
import { useOfferingSetupHeaderQuery } from '../../offering-setup/components/design-system/page/hooks/useOfferingSetupHeaderQuery';

type UseOfferingSetupIsReadOnly = {
  isReadOnly: boolean;
  isDiscarded: boolean;
  isLoading?: boolean;
};

export function useOfferingSetupIsReadOnly(offeringId?: string): UseOfferingSetupIsReadOnly {
  const { offering, loading } = useOfferingSetupHeaderQuery({
    offeringId,
    skip: !offeringId,
  });

  const isDiscarded =
    offering?.stage === OfferingStage.Discarded || offering?.stage === OfferingStage.Erroneous;
  const isLoading = !!offeringId && loading;
  const isReadOnly = isDiscarded || isLoading;

  return { isReadOnly, isDiscarded, isLoading };
}
